import React, { useState } from "react";
import Paragraph from "antd/lib/typography/Paragraph";
import { PageSection } from "../../components/Layout/PageSection";
import { Page } from "../../components/Layout/Page";
import Text from "antd/lib/typography/Text";
import { Alert, Button, Col, message, notification, Row } from "antd";
import { SectionHeader } from "../../components/SectionHeader/SectionHeader";
import Sidebar from "../../components/Sidebar/Sidebar";
import { post } from "../../config/Axios";

const DangerzonePage: React.FC = () => {
  const cleanUpSubscriptionIds = async () => {
    try {
      await post({ path: "/stripe/admin/subscription-clean-routine" });
      message.success("Started clean up successfully");
    } catch (error) {
      notification.error({
        message: "That didn't work, tell Stephen",
        placement: "bottomRight",
      });
    }
  };

  return (
    <Sidebar
      content={() => {
        return (
          <Page title="Danger Zone">
            <Row gutter={[0, 32]}>
              <Col>
                <Alert
                  type="warning"
                  showIcon
                  description={
                    <Paragraph>
                      Welcome to the danger zone. Don't use this area if you do
                      not know what anything does, or have not been told what to
                      do
                    </Paragraph>
                  }
                  message={<Text type="danger">DANGER ZONE</Text>}
                />
              </Col>
            </Row>
            <PageSection
              header={() => (
                <SectionHeader
                  text="Database"
                  subtext="Run operations on the database"
                />
              )}
            >
              <Row>
                <Col>
                  <Button danger onClick={cleanUpSubscriptionIds}>
                    Clean up subscription IDs
                  </Button>
                </Col>
              </Row>
            </PageSection>
          </Page>
        );
      }}
    />
  );
};

export default DangerzonePage;
